const postFeatureFlags = {
  toastr: 'Updated tenant',
  toastr1: ' has been updated successfully'
};

export default postFeatureFlags;
